import { render, staticRenderFns } from "./AddAlerts.vue?vue&type=template&id=67e0175c&scoped=true"
import script from "./AddAlerts.vue?vue&type=script&lang=js"
export * from "./AddAlerts.vue?vue&type=script&lang=js"
import style0 from "./AddAlerts.vue?vue&type=style&index=0&id=67e0175c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e0175c",
  null
  
)

export default component.exports